/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursahooks.UrsaHookEventName
*/
export var UrsaHookEventName;
(function (UrsaHookEventName) {
    UrsaHookEventName["PROCESS_COMPLETED"] = "PROCESS_COMPLETED";
    UrsaHookEventName["PROCESS_FAILED"] = "PROCESS_FAILED";
    UrsaHookEventName["INBOX_ITEM_CREATED"] = "INBOX_ITEM_CREATED";
    UrsaHookEventName["SESSION_SUSPENDED"] = "SESSION_SUSPENDED";
    UrsaHookEventName["SESSION_RESUMED"] = "SESSION_RESUMED";
    UrsaHookEventName["INSIGHT_SAVED"] = "INSIGHT_SAVED";
    UrsaHookEventName["RELATION_CREATED"] = "RELATION_CREATED";
})(UrsaHookEventName || (UrsaHookEventName = {}));
//# sourceMappingURL=UrsaHookEventName.js.map